import http from "./httpService";
import { apiUrl } from "../config.json";

const apiEndPoint = apiUrl + "/question";
function questionUrl(id) {
  return apiEndPoint + "/" + id;
}

export function getQuestions() {
  return http.get(apiEndPoint);
}
export function getQuestion(movieId) {
  return http.get(questionUrl(movieId));
}

export function saveQuestion(movie) {
  if (movie._id) {
    const body = { ...movie };
    delete body._id;

    return http.put(questionUrl(movie._id), body);
  }
  http.post(apiEndPoint, movie);
}

export function deleteQuestion(movieId) {
  return http.delete(questionUrl(movieId));
}
